import React, {
    useContext,
} from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLUmbrellaWatercraftOperators({ data, show }) {
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);

    if (_.isEmpty(data)) {
        return null;
    }

    const getTypeListDisplayName = (typelist, value) => {
        if (!value) {
            return undefined;
        }
        return viewModelService.productMetadata.get('pc').types.getTypelist(typelist).getCode(value).name;
    };

    const translateTypeKey = (typekey) => {
        if (typekey) {
            return translator({id: typekey, defaultMessage: typekey});
        }
    }

    const generateHeader = () => {
        return (
            <thead>
                <tr>
                    <th>{translator(messages.Name)}</th>
                    <th>{translator(messages.DOB)}</th>
                    <th>{translator(messages.Gender)}</th>
                    <th>{translator(messages.RelationshipToInsured)}</th>
                </tr>
            </thead>
        );
    }

    if (show) {
        return (
            <div className="vertical-spacing-40">
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.WatercraftOperators)}
                </h2>
                <table className={cx('table table-striped', styles.tableStriped)}>
                    {generateHeader()}
                    <tbody>
                        {data.map((operator) => {
                            return (
                                <>
                                    <tr>
                                        <td><strong>{operator.contact.displayName}</strong></td>
                                        <td>{MLLocalDateUtil.localDate2Date(operator.contact.dateOfBirth, true)}</td>
                                        <td>{translateTypeKey(getTypeListDisplayName('GenderType', operator.contact.gender))}</td>
                                        <td>{translateTypeKey(getTypeListDisplayName('InsuredRelationType_ML', operator.relationshipToInsured))}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
    return ( <></> );
}

MLUmbrellaWatercraftOperators.propTypes = {
    data: PropTypes.shape([]),
    show: PropTypes.bool
};
MLUmbrellaWatercraftOperators.defaultProps = {
    data: [],
    show: false
};
export default MLUmbrellaWatercraftOperators;
